// BB — Collections: turns the collection links above the grid into tabs that swap the product panel in
// place. All panels are rendered by Liquid; this only shows one and hides the rest. Without this script,
// the tabs stay ordinary links to each collection.
if (!customElements.get('bb-collection-tabs')) {
  customElements.define(
    'bb-collection-tabs',
    class BBCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        if (this.tabs.length === 0) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(tab);
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        // In the theme editor, selecting a collection block shows its tab.
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const tab = this.tabs.find((candidate) => candidate.dataset.blockId === event.detail.blockId);
          if (tab) this.select(tab, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(activeTab, moveFocus = true) {
        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;

          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !selected;
          if (selected) {
            // Restart the fade-in each time a panel is shown.
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        if (moveFocus) activeTab.focus();
      }

      // Arrow keys move between tabs; Home and End jump to the first and last.
      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const targets = { ArrowRight: index === last ? 0 : index + 1, ArrowLeft: index === 0 ? last : index - 1, Home: 0, End: last };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.select(this.tabs[targets[event.key]]);
      }
    }
  );
}
